import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white border-t-2 border-brand mt-24">
      <div className="max-w-[1400px] mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="h-8 w-8 bg-brand flex items-center justify-center font-display font-black text-black text-xl">M</div>
            <span className="font-display font-black text-2xl tracking-tighter">MAQUI<span className="text-brand">PRO</span></span>
          </div>
          <p className="text-sm text-white/60 leading-relaxed">
            Alquiler y venta de maquinaria pesada para minería y construcción. Equipos certificados y soporte técnico integral.
          </p>
        </div>
        <div>
          <h4 className="overline text-brand mb-4">Navegación</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/catalogo" className="hover:text-brand transition-colors">Catálogo</Link></li>
            <li><Link to="/mapa" className="hover:text-brand transition-colors">Mapa de equipos</Link></li>
            <li><Link to="/contratos" className="hover:text-brand transition-colors">Contratos</Link></li>
            <li><Link to="/registro" className="hover:text-brand transition-colors">Crear cuenta</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="overline text-brand mb-4">Sectores</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li>Minería a tajo abierto</li>
            <li>Construcción civil</li>
            <li>Obras viales</li>
            <li>Movimiento de tierras</li>
          </ul>
        </div>
        <div>
          <h4 className="overline text-brand mb-4">Contacto</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li>Av. Industrial 1200, Lima</li>
            <li>+51 900 000 000</li>
            <li>ventas@maquipro.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} MaquiPro S.A.C. — Todos los derechos reservados.
      </div>
    </footer>
  );
}
